import isObject from 'lodash-es/isObject';

import { create, v, w } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/widgets/middleware/theme';

// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { WNodeFactory, WidgetProperties, DNode } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ThemeProperties } from '@dojo/framework/core/middleware/theme';

import { TopicDef, TopicDetails } from 'lcc-state/interfaces';
import { GenerateItem, ItemType } from '../topic-widgets/generate-item';

export interface TitleProperties {
	title: string | TopicDef;
	widgetType?: string | null;
	insection: boolean;
}

const captions = new Set(['HCFigureCaption', 'HCCaptionTable']);

const factory = create({ theme }).properties<TitleProperties>();

export const Title = factory(({ properties }) => {
	const { title, widgetType = null, insection } = properties();
	let ele = widgetType === 'figure' ? (insection ? 'h6' : 'h5') : insection ? 'h4' : 'h1';
	let id: string | undefined = undefined;
	const kids: DNode[] = [];

	if (typeof title === 'string') {
		kids.push(title);
	} else {
		const { children = [], attributes } = (
			isObject(title) && 'title' in (title as any) ? (title as any).title : title
		) as TopicDetails;

		if (attributes && attributes.outputclass && captions.has(attributes.outputclass)) {
			ele = 'figcaption';
			id = attributes.id;
		}
		if (children) {
			children.forEach((kid) => {
				const item: ItemType = kid as ItemType;
				kids.push(w(GenerateItem, { item }));
			});
		} else {
			kids.push(v('span', ['']));
		}
	}
	return v(ele, { id }, kids);
});
